import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary] Uncaught error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-[#0D1B2A] p-4">
          <div className="text-center max-w-md">
            <div className="text-4xl mb-4">🔄</div>
            <h1 className="text-xl font-bold text-white mb-2">Oups !</h1>
            <p className="text-slate-400 mb-6 text-sm">
              Un problème est survenu lors du chargement de l'application.
              <br />Veuillez rafraîchir la page.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="bg-teal text-white px-8 py-3 rounded-full font-bold uppercase tracking-wider hover:opacity-90 transition-all"
              style={{ backgroundColor: '#0E7C7B' }}
            >
              Recharger
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
